import AdminMenu from './AdminMenu'

export default AdminMenu